import { type ReactNode } from 'react'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { useAppState } from '../../state/store'

/** Estructura raíz: sidebar + (header sobre contenido enrutado). */
export function AppLayout({ children }: { children: ReactNode }) {
  const { state } = useAppState()

  return (
    <div className={state.sidebarOpen ? 'layout layout--sidebar-open' : 'layout'}>
      <Sidebar />
      <div className="layout__main">
        <Header />
        <main className="content" id="main-content" tabIndex={-1}>
          {children}
        </main>
      </div>
    </div>
  )
}
